export default __webpack_public_path__ + "locales/ru/Notifications.json?hash=390c7adbc5ba5df86bbb218a2a7fc2a2";